module.exports = __webpack_public_path__ + "img/essay.34d0a9b8.png";